import { useState } from "react";
import axios from "axios";
import { API } from "../../config/trading";
import { apiErrorMessage } from "../../lib/errorMessage";

export function EmergencyStopSell({ loadDashboard }) {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  const execute = async () => {
    try {
      const response = await axios.post(`${API}/emergency/stop-and-sell`, { confirm: true, include_live: true });
      setMessage(`${response.data.message} Paper sells: ${response.data.paper_orders.length}. Live sells: ${response.data.live_orders.length}.`);
      setOpen(false);
      await loadDashboard();
    } catch (err) {
      setMessage(apiErrorMessage(err, "Stop and sell failed."));
    }
  };

  return (
    <section className="panel emergency-panel" data-testid="emergency-stop-sell-panel">
      <div className="panel-head">
        <div><span className="label">EMERGENCY EXIT</span><h2>Stop + Sell All to USDT</h2></div>
        <button data-testid="open-stop-sell-modal-button" className="danger-button" onClick={() => setOpen(true)}>Stop & Sell All</button>
      </div>
      <p className="notice loss-guard" data-testid="stop-sell-warning">Stops automation first, then sells paper assets and attempts live OKX Trading assets to USDT.</p>
      {message && <p className="notice" data-testid="stop-sell-result-message">{message}</p>}
      {open && (
        <div className="modal-backdrop" data-testid="stop-sell-modal">
          <div className="modal-panel">
            <span className="label">CONFIRM EXIT</span>
            <h2>Sell all assets to USDT?</h2>
            <p>This can realize losses. Automation will stop before selling. Live OKX sells use market orders.</p>
            <div className="modal-actions">
              <button data-testid="cancel-stop-sell-button" className="secondary-button" onClick={() => setOpen(false)}>Cancel</button>
              <button data-testid="confirm-stop-sell-button" className="danger-button" onClick={execute}>Confirm Sell All</button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}